import type { QueryClient } from '@tanstack/react-query';
import {
  getVatNumberForOrg,
  getVatNumberForOrgKey,
} from 'components/OnboardingV3/onboardingV3.service';
import { bankingServices } from 'services/banking.service';

export const getBankAccountsForBrandKey = 'getBankAccountsForBrand';
export const getBankAccountsForBrandQuery = (queryClient: QueryClient, brandId: string) =>
  queryClient.fetchQuery({
    queryKey: [getBankAccountsForBrandKey, brandId],
    queryFn: () => bankingServices.getBankAccounts(brandId),
  });

export const getVatNumberForOrgQuery = (queryClient: QueryClient, orgId: string) =>
  queryClient.fetchQuery({
    queryKey: [getVatNumberForOrgKey, orgId],
    queryFn: () => getVatNumberForOrg(orgId),
  });
